var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBug = function SvgBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    style: {
      enableBackground: "new 0 0 21 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1c2.8 0 4.7 2.2 5 4.5 0 .3-.2.5-.5.5h-9c-.3 0-.5-.2-.5-.5C6.3 3.2 8.2 1 11 1zM6 8H5c-1.1 0-2-.9-2-2V5c0-.6-.4-1-1-1s-1 .4-1 1v1c0 2.2 1.8 4 4 4h.5c.3 0 .5.2.5.5s-.2.5-.5.5H2c-.6 0-1 .4-1 1s.4 1 1 1h3.8c.2 0 .4.2.5.4.1.3-.1.7-.4.8-1.7.5-2.9 2-2.9 3.8v1c0 .6.4 1 1 1s1-.4 1-1v-1c0-1.1.9-2 2-2h2.5c.3 0 .5-.2.5-.5V9c0-.5-.5-1-1-1H6zM16.5 10c-.3 0-.5.2-.5.5s.2.5.5.5H20c.6 0 1 .4 1 1s-.4 1-1 1h-3.7c-.2 0-.4.2-.5.4-.1.3.1.7.4.8 1.6.5 2.8 2 2.8 3.8v1c0 .6-.4 1-1 1s-1-.4-1-1v-1c0-1.1-.9-2-2-2h-2.5c-.3 0-.5-.2-.5-.5V9c0-.4.5-1 1-1h4c1.1 0 2-.9 2-2V5c0-.6.4-1 1-1s1 .4 1 1v1c0 2.2-1.8 4-4 4h-.5z"
  })));
};
export default SvgBug;